import 'cross-fetch/polyfill'; // @link https://github.com/openai/openai-node/issues/304#issuecomment-1714386085
import OpenAI from 'openai';

export const openAI = new OpenAI({
  apiKey: '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', // move to .env, when using a paid one
  dangerouslyAllowBrowser: true,
});
